import { useEffect } from 'react';
const useKeyBindings = _ref => {
  let {
    editorRef,
    monacoInstance,
    provideKeyBindings
  } = _ref;
  useEffect(() => {
    var _editorRef$current;
    const editor = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.editor;
    if (editor == null || monacoInstance == null) {
      return;
    }
    const bindings = provideKeyBindings === null || provideKeyBindings === void 0 ? void 0 : provideKeyBindings(editor, monacoInstance);
    if (bindings == null) {
      return;
    }
    bindings.forEach(_ref2 => {
      let {
        callback,
        id,
        keyBindings,
        preCondition
      } = _ref2;
      editor.addAction({
        id,
        keybindings: keyBindings,
        label: id,
        precondition: preCondition,
        run: callback
      });
    });

    // eslint-disable-next-line consistent-return
    return () => {
      bindings.forEach(_ref3 => {
        let {
          id,
          keyBindings,
          preCondition
        } = _ref3;
        editor.addAction({
          id,
          keybindings: keyBindings,
          label: id,
          precondition: preCondition,
          run: () => {
            // Do nothing
          }
        });
      });
    };
  }, [editorRef, monacoInstance, provideKeyBindings]);
};
export default useKeyBindings;